import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQueries } from 'react-query';
import { useAuthTenant } from 'store/auth';
import styled from 'styled-components';
import { getAreasShort } from 'services/areas-service';
import { getProcessesShort } from 'services/processes-service';
import { getSystemsShort } from 'services/systems-service';
import { Autocomplete } from 'Components/ui';

const INK = 'var(--vo-ink)';
const MUTED = 'var(--vo-slate)';

const Card = styled.div`
  max-width: 800px;
  background: white;
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
`;
const SectionTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${INK};
  margin: 0 0 4px;
`;
const SectionSub = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${MUTED};
  margin: 0 0 24px;
`;
const FieldsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const FieldWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const Label = styled.label`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-ink-2);
`;

const isSameRecord = (option, val) => option._id === val._id;

export const Vinculos = ({ control }) => {
  const { t } = useTranslation(['asm']);
  const selectedTenant = useSelector(useAuthTenant);

  const queries = useQueries([
    {
      queryKey: ['getAreas'],
      queryFn: async () => {
        if (!selectedTenant.slug) return [];
        const r = await getAreasShort(selectedTenant.slug);
        return r?.data?.length > 0 ? r.data : [];
      },
    },
    {
      queryKey: ['getProcesses'],
      queryFn: async () => {
        if (!selectedTenant.slug) return [];
        const r = await getProcessesShort(selectedTenant.slug);
        return r?.data?.length > 0 ? r.data : [];
      },
    },
    {
      queryKey: ['getSystems'],
      queryFn: async () => {
        if (!selectedTenant.slug) return [];
        const r = await getSystemsShort(selectedTenant.slug);
        return r?.data?.length > 0 ? r.data : [];
      },
    },
  ]);

  const [{ data: areas }, { data: processes }, { data: systems }] = queries;

  return (
    <Card>
      <SectionTitle>{t('asm:assets.form.bondsSection.sectionTitle')}</SectionTitle>
      <SectionSub>{t('asm:assets.form.bondsSection.sectionSubtitle')}</SectionSub>
      <FieldsWrap>
        <FieldWrap>
          <Label>{t('asm:assets.form.bondsSection.areas')}</Label>
          <Controller
            control={control}
            name="areas"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                multiple
                filterSelectedOptions
                isOptionEqualToValue={isSameRecord}
                options={(areas || []).filter(item => !item.archived)}
                getOptionLabel={(item) => item.name}
                value={value || []}
                onChange={onChange}
                placeholder={t('asm:assets.form.bondsSection.searchArea')}
              />
            )}
          />
        </FieldWrap>
        <FieldWrap>
          <Label>{t('asm:assets.form.bondsSection.processes')}</Label>
          <Controller
            control={control}
            name="processes"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                multiple
                filterSelectedOptions
                isOptionEqualToValue={isSameRecord}
                options={(processes || []).filter(item => !item.archived)}
                getOptionLabel={(item) => item.name}
                value={value || []}
                onChange={onChange}
                placeholder={t('asm:assets.form.bondsSection.searchProcess')}
              />
            )}
          />
        </FieldWrap>
        <FieldWrap>
          <Label>{t('asm:assets.form.bondsSection.systems')}</Label>
          <Controller
            control={control}
            name="systems"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                multiple
                filterSelectedOptions
                isOptionEqualToValue={isSameRecord}
                options={(systems || []).filter(item => !item.archived)}
                getOptionLabel={(item) => item.name}
                value={value || []}
                onChange={onChange}
                placeholder={t('asm:assets.form.bondsSection.searchSystem')}
              />
            )}
          />
        </FieldWrap>
      </FieldsWrap>
    </Card>
  );
};
